<template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-card flat
            v-if="description && description.trim().length > 0"
          >
            <div class="px-5">
              <article dir="auto" v-html="this.getYoutube(description)"></article>
            </div>
          </v-card>
          <NoData v-else />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import NoData from "@/components/noData.vue";
export default {
  components: {
    NoData,
  },
  name: "Description",
  props: {
    description: {
      type: String,
      required: true,
    },
    allowEdit: {
      type: Boolean,
      default: false,
    },
  },

};
</script>

